//This graph not working properly in mobile view


// import React, { useEffect, useState } from "react";
// import {
//   Bar,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
//   ComposedChart,
//   LabelList,
//   Legend,
// } from "recharts";
// import { InverterDetail2 } from "../../../../../../api/Api";
// import { Refresh } from "@mui/icons-material"; // Import icons
// import IconButton from "@mui/material/IconButton";
// import CircularProgress from "@mui/material/CircularProgress"; // Loading spinner
// import { AuthenticationContext } from "../../../../../../context/AuthenticationContext";


// const DashboardTab6 = () => {
//   const { LoggedInUserInfo } = React.useContext(AuthenticationContext)
//   const [chartData, setChartData] = useState([]);
//   const [loading, setLoading] = useState(false); // Loading state
//   const [tye] = useState("I");


//   // Move credentials logic into a separate function to keep it dynamic
//   const getCredentials = () => ({
//     LOGIN_ID: sessionStorage.getItem("LoginID") || "",
//     LOC_CODE: sessionStorage.getItem("LCODE") || "",
//     PASS_KEY: sessionStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
//     WEB_KEY: sessionStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
//     TYE: tye,
//   });

//   // Fetch data from the API
//   const fetchLogData = async () => {
//     setLoading(true); // Set loading to true before fetching data
//     const credentials = getCredentials(); // Get the latest credentials
//     try {
//       const res = await InverterDetail2(credentials);

//       if (res?.data && Array.isArray(res.data)) {
//         console.log("Fetched Data:", res.data);
//         const transformedData = res.data.map((item) => ({
//           name: item.NAME, // Replace with appropriate key for labels
//           Peak_KW: parseFloat(item.KW_MAX) || 0, // Replace with the key for peak KW
//           KWp: parseFloat(item.KWP) || 0, // Replace with the key for KWp
//           KW: parseFloat(item.KW) || 0, // Replace with the key for KW
//           DAY_KWH: parseFloat(item.DAY_KWH) || 0, // Add daily kWh
//         }));

//         setChartData(transformedData);
//       } else {
//         console.error("Data structure mismatch:", res);
//         setChartData([]); // Set empty array on data mismatch
//       }
//     } catch (err) {
//       console.error("Error fetching data:", err);
//     } finally {
//       setLoading(false); // Set loading to false after data is fetched
//     }
//   };

//   // Fetch data on component mount
//   useEffect(() => {
//     fetchLogData();
//   }, []); // Empty dependency array to run only once on mount



//   return (
//     <>
//       <div className="row">
//         <div className="col-md-12" style={{ height: 480, position: "relative" }}>
//           {/* Refresh Button */}
//           <div style={{
//             marginBottom: "4px", cursor: "pointer",
//             position: "absolute",
//             top: "10px",
//             right: "10px",
//             zIndex: 1,
//             color: "#808080",
//             fontSize: "24px",
//           }}>
//             <IconButton onClick={fetchLogData} disabled={loading}>
//               <Refresh />
//             </IconButton>
//             {loading && <CircularProgress size={24} style={{ marginLeft: "10px" }} />}
//           </div>

//           {/* Chart */}
//           {loading ? (
//             <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
//               <CircularProgress />
//             </div>
//           ) : (
//             <ResponsiveContainer>
//               <ComposedChart
//                 data={chartData}
//                 margin={{ top: 20, right: 40, left: 40, bottom: 5 }}
//               >
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="name" />
//                 <YAxis yAxisId="left" />
//                 <YAxis yAxisId="right" orientation="right" />
//                 <Tooltip />

//                 {/* Add Legend */}
//                 <Legend
//                   layout="horizontal"
//                   verticalAlign="top"
//                   align="center"
//                   wrapperStyle={{
//                     paddingBottom: "10px", // Space between legend and chart
//                     fontSize: "12px", // Adjust font size
//                   }}
//                 />

//                 {/* Bars for Peak KW, KWp, and KW */}
//                 <Bar dataKey="Peak_KW" fill="#808080" name="Peak KW" yAxisId="left">
//                   <LabelList
//                     dataKey="Peak_KW"
//                     position="top"
//                     style={{ fill: "#808080", fontSize: "12px", fontWeight: "bold" }}
//                   />
//                 </Bar>
//                 <Bar dataKey="KWp" fill={LoggedInUserInfo.dash_color} name="KWp" yAxisId="left">
//                   <LabelList
//                     dataKey="KWp"
//                     position="top"
//                     style={{ fill: LoggedInUserInfo.dash_color, fontSize: "12px", fontWeight: "bold" }}
//                   />
//                 </Bar>
//                 <Bar dataKey="KW" fill="#0000ff" name="KW" yAxisId="left">
//                   <LabelList
//                     dataKey="KW"
//                     position="top"
//                     style={{ fill: "#0000ff", fontSize: "12px", fontWeight: "bold" }}
//                   />
//                 </Bar>

//                 {/* Line for DAY_KWH with data labels */}
//                 <Line
//                   type="monotone"
//                   dataKey="DAY_KWH"
//                   stroke="#ff0000"
//                   name="Daily kWh"
//                   yAxisId="right"
//                 >
//                   <LabelList
//                     dataKey="DAY_KWH"
//                     position="top"
//                     style={{ fill: "#ff0000", fontSize: "12px", fontWeight: "bold" }}
//                   />
//                 </Line>
//               </ComposedChart>
//             </ResponsiveContainer>
//           )}
//         </div>

//       </div>
//     </>





//   );
// };

// export default DashboardTab6;


// 2.

// import React, { useEffect, useState } from "react";
// import {
//   Bar,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
//   ComposedChart,
//   LabelList,
//   Legend,
//   Brush, // Import Brush for zoom functionality
// } from "recharts";
// import { InverterDetail2 } from "../../../../../../api/Api";
// import { Refresh } from "@mui/icons-material"; // Import icons
// import IconButton from "@mui/material/IconButton";
// import CircularProgress from "@mui/material/CircularProgress"; // Loading spinner
// import { AuthenticationContext } from "../../../../../../context/AuthenticationContext";

// const DashboardTab6 = () => {
//   const { LoggedInUserInfo } = React.useContext(AuthenticationContext)
//   const [chartData, setChartData] = useState([]);
//   const [loading, setLoading] = useState(false); // Loading state
//   const [tye] = useState("I");

//   // Move credentials logic into a separate function to keep it dynamic
//   const getCredentials = () => ({
//     LOGIN_ID: sessionStorage.getItem("LoginID") || "",
//     LOC_CODE: sessionStorage.getItem("LCODE") || "",
//     PASS_KEY: sessionStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
//     WEB_KEY: sessionStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
//     TYE: tye,
//   });

//   // Fetch data from the API
//   const fetchLogData = async () => {
//     setLoading(true); // Set loading to true before fetching data
//     const credentials = getCredentials(); // Get the latest credentials
//     try {
//       const res = await InverterDetail2(credentials);

//       if (res?.data && Array.isArray(res.data)) {
//         // console.log("Fetched Data:", res.data);
//         const transformedData = res.data.map((item) => ({
//           name: item.NAME, // Replace with appropriate key for labels
//           Peak_KW: parseFloat(item.KW_MAX) || 0, // Replace with the key for peak KW
//           KWp: parseFloat(item.KWP) || 0, // Replace with the key for KWp
//           KW: parseFloat(item.KW) || 0, // Replace with the key for KW
//           DAY_KWH: parseFloat(item.DAY_KWH) || 0, // Add daily kWh
//         }));

//         setChartData(transformedData);

//       } else {
//         // console.error("Data structure mismatch:", res);
//         setChartData([]); // Set empty array on data mismatch
//       }
//     } catch (err) {
//       // console.error("Error fetching data:", err);
//     } finally {
//       setLoading(false); // Set loading to false after data is fetched
//     }
//   };

//   // Fetch data on component mount
//   useEffect(() => {
//     fetchLogData();
//   }, []); // Empty dependency array to run only once on mount
  

//   return (
//     <>
//       <div className="row">
//         <div className="col-md-12" style={{ height: 480, position: "relative" }}>
//           {/* Refresh Button */}
//           <div style={{
//             marginBottom: "4px", cursor: "pointer",
//             position: "absolute",
//             top: "10px",
//             right: "10px",
//             zIndex: 1,
//             color: "#808080",
//             fontSize: "24px",
//           }}>
//             <IconButton onClick={fetchLogData} disabled={loading}>
//               <Refresh />
//             </IconButton>
//             {loading && <CircularProgress size={24} style={{ marginLeft: "10px" }} />}
//           </div>

//           {/* Chart */}
//           {loading ? (
//             <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
//               <CircularProgress />
//             </div>
//           ) : (
//             <ResponsiveContainer>
//               <ComposedChart
//                 data={chartData}
//                 margin={{ top: 20, right: 40, left: 40, bottom: 5 }}
//               >
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="name" />
//                 <YAxis yAxisId="left" />
//                 <YAxis yAxisId="right" orientation="right" />
//                 <Tooltip />

//                 {/* Add Legend */}
//                 <Legend
//                   layout="horizontal"
//                   verticalAlign="top"
//                   align="center"
//                   wrapperStyle={{
//                     paddingBottom: "10px", // Space between legend and chart
//                     fontSize: "12px", // Adjust font size
//                   }}
//                 />

//                 {/* Bars for Peak KW, KWp, and KW */}
//                 <Bar dataKey="Peak_KW" fill="#808080" name="Peak KW" yAxisId="left">
//                   <LabelList
//                     dataKey="Peak_KW"
//                     position="top"
//                     style={{ fill: "#808080", fontSize: "12px", fontWeight: "bold" }}
//                   />
//                 </Bar>
//                 <Bar dataKey="KWp" fill={LoggedInUserInfo.dash_color} name="KWp" yAxisId="left">
//                   <LabelList
//                     dataKey="KWp"
//                     position="top"
//                     style={{ fill: LoggedInUserInfo.dash_color, fontSize: "12px", fontWeight: "bold" }}
//                   />
//                 </Bar>
//                 <Bar dataKey="KW" fill="#0000ff" name="KW" yAxisId="left">
//                   <LabelList
//                     dataKey="KW"
//                     position="top"
//                     style={{ fill: "#0000ff", fontSize: "12px", fontWeight: "bold" }}
//                   />
//                 </Bar>

//                 {/* Line for DAY_KWH with data labels */}
//                 <Line
//                   type="monotone"
//                   dataKey="DAY_KWH"
//                   stroke="#ff0000"
//                   name="Daily kWh"
//                   yAxisId="right"
//                   strokeWidth={2}
//                 >
//                   <LabelList
//                     dataKey="DAY_KWH"
//                     position="top"
//                     style={{ fill: "#ff0000", fontSize: "12px", fontWeight: "bold" }}
//                   />
//                 </Line>

//                 {/* Brush Component for Zooming */}
//                 <Brush
//                   dataKey="name"
//                   height={30}
//                   stroke="#8884d8"
//                   startIndex={0}
//                   endIndex={10}
//                 />
//               </ComposedChart>
//             </ResponsiveContainer>
//           )}
//         </div>
//       </div>
//     </>
//   );
// };

// export default DashboardTab6;

// 3. jpeg image bali

// import React, { useEffect, useState, useRef } from "react";
// import {
//   Bar,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
//   ComposedChart,
//   LabelList,
//   Legend,
//   Brush,
// } from "recharts";
// import { InverterDetail2 } from "../../../../../../api/Api";
// import { Refresh } from "@mui/icons-material";
// import IconButton from "@mui/material/IconButton";
// import CircularProgress from "@mui/material/CircularProgress";
// import Button from "@mui/material/Button";
// import { AuthenticationContext } from "../../../../../../context/AuthenticationContext";
// import { toJpeg } from "html-to-image";

// const DashboardTab6 = () => {
//   const { LoggedInUserInfo } = React.useContext(AuthenticationContext);
//   const [chartData, setChartData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [tye] = useState("I");

//   // Chart container ref
//   const chartRef = useRef();

//   const getCredentials = () => ({
//     LOGIN_ID: sessionStorage.getItem("LoginID") || "",
//     LOC_CODE: sessionStorage.getItem("LCODE") || "",
//     PASS_KEY: sessionStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
//     WEB_KEY: sessionStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
//     TYE: tye,
//   });

//   const fetchLogData = async () => {
//     setLoading(true);
//     const credentials = getCredentials();
//     try {
//       const res = await InverterDetail2(credentials);
//       if (res?.data && Array.isArray(res.data)) {
//         const transformedData = res.data.map((item) => ({
//           name: item.NAME,
//           Peak_KW: parseFloat(item.KW_MAX) || 0,
//           KWp: parseFloat(item.KWP) || 0,
//           KW: parseFloat(item.KW) || 0,
//           DAY_KWH: parseFloat(item.DAY_KWH) || 0,
//         }));
//         setChartData(transformedData);
//       } else {
//         setChartData([]);
//       }
//     } catch (err) {
//       /* Handle error */
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchLogData();
//   }, []);

//   // Download chart as JPEG
//   const handleDownloadJpeg = () => {
//     if (!chartRef.current) return;
//     toJpeg(chartRef.current, { quality: 0.95 }).then((dataUrl) => {
//       const link = document.createElement("a");
//       link.download = "chart.jpeg";
//       link.href = dataUrl;
//       link.click();
//     });
//   };

//   return (
//     <>
//       <div className="row">
//         <div className="col-md-12" style={{ height: 520, position: "relative" }}>
//           {/* Export and Refresh Buttons */}
//           <div
//             style={{
//               marginBottom: "4px",
//               position: "absolute",
//               top: "10px",
//               right: "10px",
//               zIndex: 2,
//               display: "flex",
//               gap: "10px",
//               alignItems: "center",
//             }}
//           >
//             <Button variant="contained" color="primary" size="small" onClick={handleDownloadJpeg}>
//               Download as JPEG
//             </Button>
//             <IconButton onClick={fetchLogData} disabled={loading}>
//               <Refresh />
//             </IconButton>
//             {loading && <CircularProgress size={24} style={{ marginLeft: "10px" }} />}
//           </div>

//           {/* Chart */}
//           <div ref={chartRef} style={{ height: 480, background: "#fff", padding: "5px" }}>
//             {loading ? (
//               <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
//                 <CircularProgress />
//               </div>
//             ) : (
//               <ResponsiveContainer>
//                 <ComposedChart
//                   data={chartData}
//                   margin={{ top: 20, right: 40, left: 40, bottom: 5 }}
//                 >
//                   <CartesianGrid strokeDasharray="3 3" />
//                   <XAxis dataKey="name" />
//                   <YAxis yAxisId="left" />
//                   <YAxis yAxisId="right" orientation="right" />
//                   <Tooltip />
//                   <Legend
//                     layout="horizontal"
//                     verticalAlign="top"
//                     align="center"
//                     wrapperStyle={{
//                       paddingBottom: "10px",
//                       fontSize: "12px",
//                     }}
//                   />
//                   <Bar dataKey="Peak_KW" fill="#808080" name="Peak KW" yAxisId="left">
//                     <LabelList
//                       dataKey="Peak_KW"
//                       position="top"
//                       style={{ fill: "#808080", fontSize: "12px", fontWeight: "bold" }}
//                     />
//                   </Bar>
//                   <Bar dataKey="KWp" fill={LoggedInUserInfo.dash_color} name="KWp" yAxisId="left">
//                     <LabelList
//                       dataKey="KWp"
//                       position="top"
//                       style={{
//                         fill: LoggedInUserInfo.dash_color,
//                         fontSize: "12px",
//                         fontWeight: "bold",
//                       }}
//                     />
//                   </Bar>
//                   <Bar dataKey="KW" fill="#0000ff" name="KW" yAxisId="left">
//                     <LabelList
//                       dataKey="KW"
//                       position="top"
//                       style={{ fill: "#0000ff", fontSize: "12px", fontWeight: "bold" }}
//                     />
//                   </Bar>
//                   <Line
//                     type="monotone"
//                     dataKey="DAY_KWH"
//                     stroke="#ff0000"
//                     name="Daily kWh"
//                     yAxisId="right"
//                     strokeWidth={2}
//                   >
//                     <LabelList
//                       dataKey="DAY_KWH"
//                       position="top"
//                       style={{ fill: "#ff0000", fontSize: "12px", fontWeight: "bold" }}
//                     />
//                   </Line>
//                   <Brush dataKey="name" height={30} stroke="#8884d8" startIndex={0} endIndex={10} />
//                 </ComposedChart>
//               </ResponsiveContainer>
//             )}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default DashboardTab6;


import React, { useEffect, useState, useRef } from "react";
import {
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ComposedChart,
  LabelList,
  Legend,
  Brush,
} from "recharts";
import { InverterDetail2 } from "../../../../../../api/Api";
import { Refresh } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";
import { AuthenticationContext } from "../../../../../../context/AuthenticationContext";
import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";
// import DownloadJpegButton from "../../../../../../components/downloadJpegButton"; 

// const DashboardTab6 = () => {
//   const { LoggedInUserInfo } = React.useContext(AuthenticationContext);
//   const [chartData, setChartData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [tye] = useState("I");

//   const chartRef = useRef();

//   const getCredentials = () => ({
//     LOGIN_ID: sessionStorage.getItem("LoginID") || "",
//     LOC_CODE: sessionStorage.getItem("LCODE") || "",
//     PASS_KEY: sessionStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
//     WEB_KEY: sessionStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
//     TYE: tye,
//   });

//   const fetchLogData = async () => {
//     setLoading(true);
//     const credentials = getCredentials();
//     try {
//       const res = await InverterDetail2(credentials);
//       if (res?.data && Array.isArray(res.data)) {
//         const transformedData = res.data.map((item) => ({
//           name: item.NAME,
//           Peak_KW: parseFloat(item.KW_MAX) || 0,
//           KWp: parseFloat(item.KWP) || 0,
//           KW: parseFloat(item.KW) || 0,
//           DAY_KWH: parseFloat(item.DAY_KWH) || 0,
//         }));
//         setChartData(transformedData);
//       } else {
//         setChartData([]);
//       }
//     } catch (err) {
//       /* Handle error */
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchLogData();
//   }, []);

//   return (
//     <>
//       <div className="row">
//         <div className="col-md-12" style={{ height: 520, position: "relative" }}>
//           {/* Export and Refresh Buttons */}
//           <div
//             style={{
//               marginBottom: "4px",
//               position: "absolute",
//               top: "10px",
//               right: "10px",
//               zIndex: 2,
//               display: "flex",
//               gap: "10px",
//               alignItems: "center",
//             }}
//           >
//             <DownloadJpegButton targetRef={chartRef}  fileName={`Peak KW vs KWp.jpeg`} />
//             <IconButton onClick={fetchLogData} disabled={loading}>
//               <Refresh />
//             </IconButton>
//             {loading && <CircularProgress size={24} style={{ marginLeft: "10px" }} />}
//           </div>

//           {/* Chart */}
//           <div ref={chartRef} style={{ height: 480, background: "#fff", padding: "5px",marginTop:"2rem" }}>
//             {loading ? (
//               <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
//                 <CircularProgress />
//               </div>
//             ) : (
//               <ResponsiveContainer>
//                 <ComposedChart
//                   data={chartData}
//                   margin={{ top: 20, right: 40, left: 40, bottom: 5 }}
//                 >
//                   <CartesianGrid strokeDasharray="3 3" />
//                   <XAxis dataKey="name" />
//                   <YAxis yAxisId="left" />
//                   <YAxis yAxisId="right" orientation="right" />
//                   <Tooltip />
//                   <Legend
//                     layout="horizontal"
//                     verticalAlign="top"
//                     align="center"
//                     wrapperStyle={{
//                       paddingBottom: "10px",
//                       fontSize: "12px",
//                     }}
//                   />
//                   <Bar dataKey="Peak_KW" fill="#808080" name="Peak KW" yAxisId="left">
//                     <LabelList
//                       dataKey="Peak_KW"
//                       position="top"
//                       style={{ fill: "#808080", fontSize: "12px", fontWeight: "bold" }}
//                     />
//                   </Bar>
//                   <Bar dataKey="KWp" fill={LoggedInUserInfo.dash_color} name="KWp" yAxisId="left">
//                     <LabelList
//                       dataKey="KWp"
//                       position="top"
//                       style={{
//                         fill: LoggedInUserInfo.dash_color,
//                         fontSize: "12px",
//                         fontWeight: "bold",
//                       }}
//                     />
//                   </Bar>
//                   <Bar dataKey="KW" fill="#0000ff" name="KW" yAxisId="left">
//                     <LabelList dataKey="KW" position="top" style={{ fill: "#0000ff", fontSize: "12px", fontWeight: "bold" }} />
//                   </Bar>
//                   <Line
//                     type="monotone"
//                     dataKey="DAY_KWH"
//                     stroke="#ff0000"
//                     name="Daily kWh"
//                     yAxisId="right"
//                     strokeWidth={2}
//                   >
//                     <LabelList
//                       dataKey="DAY_KWH"
//                       position="top"
//                       style={{ fill: "#ff0000", fontSize: "12px", fontWeight: "bold" }}
//                     />
//                   </Line>
//                   <Brush dataKey="name" height={30} stroke="#8884d8" startIndex={0} endIndex={10} />
//                 </ComposedChart>
//               </ResponsiveContainer>
//             )}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default DashboardTab6;



const DashboardTab6 = () => {
  const { LoggedInUserInfo } = React.useContext(AuthenticationContext);
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tye] = useState("I");

  const chartRef = useRef();

  // LoggedInUserInfo null होने पर एरर से बचने के लिए सुरक्षित रंग (Fallback color)
  const dashColor = LoggedInUserInfo?.dash_color || "#8884d8";

  const getCredentials = () => ({
    LOGIN_ID: sessionStorage.getItem("LoginID") || "",
    LOC_CODE: sessionStorage.getItem("LCODE") || "",
    PASS_KEY: sessionStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
    WEB_KEY: sessionStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
    TYE: tye,
  });

  const fetchLogData = async () => {
    setLoading(true);
    const credentials = getCredentials();
    try {
      const res = await InverterDetail2(credentials);
      if (res?.data && Array.isArray(res.data)) {
        const transformedData = res.data.map((item) => ({
          name: item.NAME,
          Peak_KW: parseFloat(item.KW_MAX) || 0,
          KWp: parseFloat(item.KWP) || 0,
          KW: parseFloat(item.KW) || 0,
          DAY_KWH: parseFloat(item.DAY_KWH) || 0,
        }));
        setChartData(transformedData);
      } else {
        setChartData([]);
      }
    } catch (err) {
      /* Handle error */
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogData();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-md-12" style={{ height: 520, position: "relative" }}>
          {/* Export and Refresh Buttons */}
          <div
            style={{
              marginBottom: "4px",
              position: "absolute",
              top: "10px",
              right: "10px",
              zIndex: 2,
              display: "flex",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <DownloadJpegButton targetRef={chartRef} fileName={`Peak KW vs KWp.jpeg`} />
            <IconButton onClick={fetchLogData} disabled={loading}>
              <Refresh />
            </IconButton>
            {loading && <CircularProgress size={24} style={{ marginLeft: "10px" }} />}
          </div>

          {/* Chart */}
          <div ref={chartRef} style={{ height: 480, background: "#fff", padding: "5px", marginTop: "2rem" }}>
            {loading ? (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <CircularProgress />
              </div>
            ) : (
              <ResponsiveContainer>
                <ComposedChart
                  data={chartData}
                  margin={{ top: 20, right: 40, left: 40, bottom: 5 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis yAxisId="left" />
                  <YAxis yAxisId="right" orientation="right" />
                  <Tooltip />
                  <Legend
                    layout="horizontal"
                    verticalAlign="top"
                    align="center"
                    wrapperStyle={{
                      paddingBottom: "10px",
                      fontSize: "12px",
                      wrapperStyle: "12px",
                    }}
                  />
                  <Bar dataKey="Peak_KW" fill="#808080" name="Today Peak KW" yAxisId="left">
                    <LabelList
                      dataKey="Peak_KW"
                      position="top"
                      style={{ fill: "#808080", fontSize: "12px", fontWeight: "bold" }}
                    />
                  </Bar>
                  
                  {/* यहाँ सुरक्षित dashColor वेरिएबल का उपयोग किया गया है */}
                  <Bar dataKey="KWp" fill={dashColor} name="Inverter Capacity kWp" yAxisId="left">
                    <LabelList
                      dataKey="KWp"
                      position="top"
                      style={{
                        fill: dashColor,
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    />
                  </Bar>

                  <Bar dataKey="KW" fill="#0000ff" name="Active Power (kW)" yAxisId="left">
                    <LabelList dataKey="KW" position="top" style={{ fill: "#0000ff", fontSize: "12px", fontWeight: "bold" }} />
                  </Bar>


                  <Line
                    type="monotone"
                    dataKey="DAY_KWH"
                    stroke="#ff0000"
                    name="Today kWh"
                    yAxisId="right"
                    strokeWidth={2}
                  >
                    <LabelList
                      dataKey="DAY_KWH"
                      position="top"
                      style={{ fill: "#ff0000", fontSize: "12px", fontWeight: "bold" }}
                    />
                  </Line>
                  <Brush dataKey="name" height={30} stroke="#8884d8" startIndex={0} endIndex={10} />
                </ComposedChart>
              </ResponsiveContainer>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardTab6;
